/**
 * @memberOf app
 * @ngdoc module
 * @description Core module of application, runs all configs for the app
 * @name app.core
 */

import angular from 'angular';
import uirouter from 'angular-ui-router';
import uibootstrap from 'angular-ui-bootstrap';
import ngFlash from 'angular-flash-alert';
import ngIdle from 'ng-idle';
import ngMaterial from 'angular-material';
import routing from './config';
import CoreController from './core.controller';
import AuthService from '../services/auth.service';
import mask from '../filters/mask.filter';
import ngSanitize from 'angular-sanitize';

export default angular.module('app.core', [uirouter, ngFlash, AuthService, mask, ngIdle, ngMaterial, uibootstrap, ngSanitize])
  .controller('CoreController', CoreController)
  .config(routing)
  .run(run)
  .name;

function run($rootScope, $state, AuthService, Idle) {
  $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
    if (!AuthService.isLoggedIn()) {
      if (!AuthService.disclaimerAccepted()) {
        $state.go('accept');
      } else {
        $state.go('login');
      }
    } else {
      if (!AuthService.disclaimerAccepted()) {
        $state.go('accept');
      } else {
        Idle.watch();
      }
    }
  });
}

run.$inject = ['$rootScope', '$state', 'AuthService', 'Idle']



// WEBPACK FOOTER //
// ./src/client/app/core/core.module.js